// The marks live's course site uses in the screens' words (its md() and scriptBlocks()), split into
// blocks for Md.jsx to draw. Pure: no React, so a test can import it.
import { COPY } from './copy.js'

// Splits text into blocks: { kind: 'p' | 'h2' | 'h3' | 'ol' | 'ul' | 'quote' | 'script', ... }
export function mdBlocks(src) {
  const lines = String(src || '').replace(/\r\n?/g, '\n').split('\n')
  const blocks = []
  let para = null
  let list = null
  let script = null
  let quote = null
  const close = () => {
    if (para) blocks.push({ kind: 'p', text: para.join(' ') })
    if (list) blocks.push(list)
    if (script) blocks.push(script)
    if (quote) blocks.push({ kind: 'quote', text: quote.join(' ') })
    para = null; list = null; script = null; quote = null
  }
  for (const raw of lines) {
    const line = raw.trimEnd()
    const say = /^>>\s?(.*)$/.exec(line)
    if (say) {
      if (!script) {
        close()
        let t = say[1]
        let label = COPY.sayThis
        const lm = /^\[([^\]]+)\]\s*(.*)$/.exec(t)
        if (lm) { label = lm[1]; t = lm[2] }
        script = { kind: 'script', label, lines: [] }
        if (t.trim()) script.lines.push(t)
      } else if (say[1].trim()) script.lines.push(say[1])
      continue
    }
    if (!line.trim()) { close(); continue }
    const h = /^(#{2,3})\s+(.*)$/.exec(line)
    if (h) { close(); blocks.push({ kind: h[1].length === 2 ? 'h2' : 'h3', text: h[2] }); continue }
    const ol = /^\d+[.)]\s+(.*)$/.exec(line)
    const ul = /^[-*]\s+(.*)$/.exec(line)
    if (ol || ul) {
      const kind = ol ? 'ol' : 'ul'
      if (!list || list.kind !== kind) { close(); list = { kind, items: [] } }
      list.items.push((ol || ul)[1])
      continue
    }
    const q = /^>\s?(.*)$/.exec(line)
    if (q) {
      if (!quote) { close(); quote = [] }
      quote.push(q[1])
      continue
    }
    if (list) {
      // a line straight after a list item carries on that item
      list.items[list.items.length - 1] += ` ${line.trim()}`
      continue
    }
    if (script || quote) close()
    if (!para) para = []
    para.push(line.trim())
  }
  close()
  return blocks
}
